import {
  Company1,
  Company2,
  Company3,
  Company4,
  Company5,
  Company6,
  Company7,
} from '@/assets/images'

// Legacy used react-slick for an auto-scrolling logo strip (outside the allowed dependency set).
// A CSS marquee gives the same continuous scroll: the track holds the list TWICE and animates to
// -50%, so the loop point lands exactly on the seam (see @keyframes companies-scroll).
export function CompaniesSection() {
  const renderCompanies = (keyPrefix: string) =>
    companies.map((company) => (
      <div key={`${keyPrefix}-${company.name}`} style={{ width: 'auto' }}>
        <img src={company.image} alt={company.name} />
      </div>
    ))

  return (
    <section className="companies-section">
      <h6>Jobs at the hottest companies</h6>

      <div className="companies-section-marquee" aria-hidden="true">
        {renderCompanies('a')}
        {renderCompanies('b')}
      </div>

      <div className="companies-section-mobile">{renderCompanies('m')}</div>
    </section>
  )
}

const companies = [
  { name: 'audiocodes', image: Company1 },
  { name: 'citi', image: Company2 },
  { name: 'hp', image: Company3 },
  { name: 'lemonade', image: Company4 },
  { name: 'lumenis', image: Company5 },
  { name: 'solaredge', image: Company6 },
  { name: 'vayyar', image: Company7 },
]
